import { formatDateHuman } from "../date-utils";
export const dossierActivityDtoFields = [{
        name: "date",
        title: "Data",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.activity.date)
    }, {
        name: "activityTypeDescription",
        title: "Causale Attività"
    }, {
        name: "title",
        title: "Descrizione aggiuntiva",
        render: (record) => record.activity.title
    }, {
        name: "elapsedTime",
        title: "Tempo",
        render: (record) => record.activity.hours.toString().padStart(2, '0') + ':' + record.activity.minutes.toString().padStart(2, '0')
    }, {
        name: "portalUserName",
        title: "Utente"
    }];
